export const getExtension = (fileName) => {
    const nameArray = fileName.split('.')

    return nameArray[nameArray.length - 1]
}